import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CashrewardsComponent } from './cashrewards.component';
import { CashRewardsTransactionsComponent } from './transactions/transactions.component';
import { CashrewardsService } from './services/cashrewards.service';
import { SharedModule } from '@app/core/shared';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    CashrewardsComponent,
    CashRewardsTransactionsComponent
  ],
  providers:[CashrewardsService],
  imports: [
    SharedModule,
    CommonModule,
    NgbModule,
    FormsModule,
    NgbAccordionModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CashrewardsModule { }

